import { Component, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';

@Component({
  selector: 'app-setingsidebar',
  templateUrl: './setingsidebar.component.html',
  styleUrls: ['./setingsidebar.component.css']
})
export class SetingsidebarComponent implements OnInit {

  constructor(private route: ActivatedRoute) { }

  ngOnInit() {
  }

}
